import { IDocumentState, IEntityState, PaginationMeta } from './interfaces';

export const NGXS_META_KEY = 'NGXS_META';

export const paginationMetaState = (): PaginationMeta => ({
  pageSize: undefined,
  pageIndex: undefined,
  totalCount: undefined,
});

export class EntityStateHelpers {
  public static createDefaultState<Meta = undefined>(
    metaState: Meta | undefined = undefined,
  ): IEntityState<any, Meta> {
    return {
      entities: {},
      ids: [],
      loading: [],
      error: {},
      active: undefined,
      latestId: undefined,
      meta: metaState,
      lastUpdated: 0,
    };
  }
}

export class DocumentStateHelpers {
  public static createDefaultState<Meta = undefined>(
    metaState: Meta | undefined = undefined,
  ): IDocumentState<any, Meta> {
    return {
      meta: metaState,
      loading: false,
      error: undefined,
      data: null,
      lastUpdated: 0,
    };
  }
}

function isObject<T>(item: T): boolean {
  return item && typeof item === 'object' && !Array.isArray(item);
}

function mergeDeep<T extends Record<string, any>>(target: T, source: T): T {
  const output = { ...(target || {}) };
  if (isObject(source)) {
    Object.keys(source).forEach(key => {
      if (isObject(source[key])) {
        if (!(key in target)) {
          Object.assign(output, { [key]: source[key] });
        } else {
          // @ts-ignore
          output[key] = mergeDeep(target[key], source[key]);
        }
      } else {
        Object.assign(output, { [key]: source[key] });
      }
    });
  }
  return output;
}

export class EntityUpdateStrategy {
  public static replace<T>(oldEntity: T, newEntity: T): T {
    return newEntity;
  }

  public static update<T>(oldEntity: T, newEntity: T): T {
    return oldEntity ? mergeDeep(oldEntity, newEntity) : newEntity;
  }
}
